import type { SVGProps } from 'react'

export const BasketMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4167 15H14.9942C16.3749 15 17.4942 13.8807 17.4942 12.5V5C17.4942 3.61929 16.3749 2.5 14.9942 2.5H4.9942C3.61349 2.5 2.4942 3.61929 2.4942 5V12.5C2.4942 13.8807 3.61349 15 4.9942 15H6.6667V17.0358C6.6667 17.2139 6.76881 17.3763 6.92937 17.4534C7.08993 17.5306 7.28051 17.5089 7.41961 17.3976L10.4167 15Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7566 6.57031H7.74343C7.52559 6.57031 7.34537 6.73896 7.3309 6.95597L7.00187 11.8889C6.97004 12.3659 7.34867 12.7706 7.82692 12.7706H12.6731C13.1513 12.7706 13.53 12.3659 13.4981 11.8889L13.1691 6.95597C13.1546 6.73896 12.9744 6.57031 12.7566 6.57031Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4906 7.39347V5.74006V5.74006V5.74006C11.4906 5.05513 10.9354 4.5 10.2505 4.5H10.2501C9.56517 4.5 9.01004 5.05513 9.01004 5.74006V5.74006V5.74006V7.39347"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
